<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="cardMaking"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign4.png"> 我的办件列表</span></h2>
              <div style="width: 100%;" v-if="card_making_list && card_making_list.length>0">
                <el-card class="box-card" shadow="hover"
                         style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                         v-for="(item,index) in card_making_list" :key="index" >
                  <div slot="header" class="clearfix">
                  <span><span style="font-weight: 600">申办业务：</span><span>{{item.archiveTypeName}}</span>
                  <span>【 <span  style="color: #c0c4cc;">{{item.applyNo}}</span> 】({{item.userName}})
                  </span>
                     <el-button v-if="item.flowStatus =='-1'||item.flowStatus =='4'  || item.applyStatusName=='驳回'"  type="primary" style="float: right; padding: 5px;font-size: 12px;margin-left: 10px"
                                @click="toDelete(item.applyId,item.archiveTypeCode,item.archiveTypeName,true)" >删除资料</el-button>
                    <el-button v-if="item.flowStatus =='-1'||item.flowStatus =='4' || item.applyStatusName=='驳回'"  type="primary" style="float: right; padding: 5px;font-size: 12px;"
                               @click="gotoEdit(item.applyId,item.archiveTypeCode,item.archiveTypeName,true)" >修改资料</el-button>
                  </span>
                   </div>
                  <div class="text item" style="line-height: 23px;margin-top: 10px;" v-if="item.flowStatus !='-1'" >
                      <el-steps :active="getCurrentStep(item)"  align-left>
                        <el-step style="font-size: 10px">
                          <template slot="title">
                            <span style="font-size:10px">提交申请</span>
                          </template>
                          <template slot="description">
                            <span style="font-size:10px">{{item.applyDate}}</span>
                          </template>
                        </el-step>
                        <el-step style="font-size: 10px">
                          <template slot="title">
                            <span style="font-size:10px" v-if="item.flowStatus<1">待受理</span>
                            <span style="font-size:10px" v-if="item.flowStatus==1">受理中</span>
                            <span style="font-size:10px" v-if="item.flowStatus>1">已受理</span>
                          </template>
                          <template slot="description">
                            <span style="font-size:10px"></span>
                          </template>
                        </el-step>
                        <el-step style="font-size: 10px">
                          <template slot="title">
                            <span style="font-size:10px" v-if="item.flowStatus<2">待审批</span>
                            <span style="font-size:10px" v-if="item.flowStatus==2&&item.applyStatusName=='驳回'">驳回</span>
                            <span style="font-size:10px" v-if="item.flowStatus==2&&item.applyStatusName!=='驳回'">审批中</span>
                            <span style="font-size:10px" v-if="item.flowStatus>2">已审批</span>
                          </template>
                          <template slot="description">
                            <span style="font-size:10px"></span>
                          </template>
                        </el-step>
                        <el-step style="font-size: 10px">
                          <template slot="title">
                            <span v-if="'审批通过'==getFinalStep(item)||'审批结束'==getFinalStep(item)" style="font-size:10px;">{{getFinalStep(item)}}</span>
                            <span v-else style="font-size:10px;color: red">{{getFinalStep(item)}}</span>
                          </template>
                          <template slot="description">
                            <span style="font-size:10px" v-if="item.flowStatus =='3'">{{item.handlTime}}</span>
                          </template>
                        </el-step>
                      </el-steps>
<!--                    <el-collapse v-model="activeName1" style="margin-top: 10px;" >-->
<!--                      <el-collapse-item title="" :name="item.applyId" class="stepDivCss">-->
<!--                        <template slot="title">-->
                    <div style="float: left;padding-bottom: 20px;padding-top: 10px;margin-right: 5px">
                      <el-button  type="primary" style=" padding: 5px;font-size: 12px;"  @click="showLog(item.applyId,item.logData)">办件记录</el-button>
                      <el-button v-if="item.flowStatus !='-1'"  type="primary" style=" padding: 5px;font-size: 12px;"
                                 @click="gotoBl(item.applyId,item.archiveTypeCode,item.archiveTypeName,false)" >申报详细</el-button>
                      <el-button  v-if="item.flowStatus !='-1' && item.isPj =='1' && item.flowStatus =='3'" type="primary" @click="showOldEvaluation(item.applyId)" style=" padding: 5px;font-size: 12px;">评价记录</el-button>
                      <el-button v-if="item.flowStatus !='-1' && item.isPj!='1'  && item.flowStatus =='3'"  type="primary" @click="initEvaluation(item.applyId)" style="float: right; padding: 5px;font-size: 12px;">我要评价</el-button>
                      <el-button v-if="item.flowStatus !='-1' && item.isTs!='1'  && item.flowStatus =='3'"  type="primary" style=" padding: 5px;font-size: 12px;" @click="urlTo('/suggest_ts',{applyId:item.applyId,partyId:item.handlePartyId,title:'投诉',type:1,source:2})">我要投诉</el-button>
                      <el-button v-if="item.flowStatus !='-1' && item.isTs=='1'  && item.flowStatus =='3'"  type="primary" style=" padding: 5px;font-size: 12px;" @click="urlTo('/personal_complaint',{type:1})">投诉记录</el-button>
                      <el-button v-if="item.flowStatus!='-1' && item.flowStatus =='3' && show==true"  type="primary" style=" padding: 5px;font-size: 12px;" @click="gotoLookEnjoy(item.applyId,item.personUid)">待遇享受</el-button>
                      <el-button v-if="item.flowStatus !='-1' && item.flowStatus =='3' && show==true"  type="primary" style=" padding: 5px;font-size: 12px;" @click="urlTo('/payList',{personUid:item.personUid})">资金发放历史</el-button>
                    </div>
                  </div>
                </el-card>
            </div>
            <div v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                <div>暂无数据</div>
              </div>
            </div>
              <div style="width: 100%;height: 50px;"></div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog  :visible.sync="enjoyApplyShow" width="900px" >
      <div v-if="enjoyList.length>0">
      <td colspan="2"><h2 class="information_tit">申报结果</h2></td>

      <div>
        <div v-if="!this.$util.isEmpty(enjoyList.personUid)">
          <h3 class="details_tit2" style="margin-top: 20px">
            <span style="margin-right: 24px">姓名：{{enjoyList.personName}}</span>
            <span style="margin-right: 24px">性别：{{enjoyList.personSexName}}</span>
            <span style="margin-right: 24px">身份证号：{{enjoyList.personUid}}</span>
          </h3>
          <div v-for="(archive,index) in enjoyList.archiveTyeData" :key="index" style="text-align: center">
            <div style="font-size:14px; color:#848484; text-align:center; padding-top:24px;width: 75%;margin: 0 auto;text-align: left;">
              <span style="margin-right: 54px"> 待遇名称：{{archive.archiveTypeName}}</span>
              <span style="float: right;margin-right: 10px;"> 状态：{{archive.archiveStatusName}}</span>
            </div>
            <table width="75%" border="0" cellspacing="1" cellpadding="0" class="enjoy_tab" style="margin-left:auto;margin-right:auto;margin-top:10px;float: none">
              <tr class="enjoy_tit">
                <td width="25%">资金科目</td>
                <td width="25%">标准金额（元）</td>
                <td width="25%">发放周期</td>
              </tr>
              <tr v-for="(classItem,index) in archive.classData" :key="index">
                <td>{{classItem.className}}</td>
                <td>{{classItem.standardAmount}}</td>
                <td>{{classItem.frequency}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      </div>
      <div v-else>
        <div class="notice_con" style="height: 450px;"  >
          <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
            <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
            <div>暂无数据</div>
          </div>
        </div>
      </div>
      <!--<li  v-for="(item,index) in enjoyList" :key="index" >-->
      <!--<div style="margin-inside: 50px">&nbsp;</div>-->
      <!--<table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">-->
        <!--<tr>-->
          <!--<td width="12%" class="grey">姓名</td>-->
          <!--<td width="38%"> {{item.personName}}</td>-->
          <!--<td width="12%" class="grey">性别</td>-->
          <!--<td width="38%" v-if="item.personSex==0">女</td>-->
          <!--<td width="38%" v-else>男</td>-->
        <!--</tr>-->
          <!--<tr>-->
            <!--<td width="12%" class="grey">身份证号</td>-->
            <!--<td width="38%"> {{item.personUid}}</td>-->
            <!--<td width="12%" class="grey">待遇名称</td>-->
            <!--<td width="38%">{{item.archive_type_code}}</td>-->
          <!--</tr>-->
        <!--<tr>-->
          <!--<td width="12%" class="grey">状态</td>-->
          <!--<td width="38%" v-if="item.archiveStatus==0"> 正常</td>-->
          <!--<td width="38%" v-else> 停发</td>-->
          <!--<td width="12%" class="grey">资金科目</td>-->
          <!--<td width="38%">{{item.className}}</td>-->
        <!--</tr>-->
        <!--<tr>-->
          <!--<td width="12%" class="grey">标准金额（元）</td>-->
          <!--<td width="38%"> {{item.standardAmount}}</td>-->
          <!--<td width="12%" class="grey">发放周期</td>-->
          <!--<td width="38%">{{item.frequency}}</td>-->
        <!--</tr>-->
      <!--</table>-->
      <!--</li>-->
    </el-dialog>
    <div class="dialog_css12" v-if="dialogVisible">
      <el-dialog
        :visible.sync="dialogVisible" :close-on-click-modal="false"
        width="600px"
      >
        <div style="width: 100%;height: 20px;"></div>
        <div style="width: 80%;margin: 0 auto;font-size: 14px;margin-top: 5px;height: 30px;line-height: 30px;">办件服务评价：</div>
        <div style="width: 80%;margin: 0 auto;font-size: 14px;line-height: 30px;border: 1px solid  #dbdbdb;padding: 10px 0px;" v-if="dataEvaluationObj !=null">
          <div style="width: 90%;margin: 0 auto;border-bottom: 1px solid #e6e6e6;" >
          <div class="div-first" style="height: 30px;line-height: 30px;">
            <div class="div-first-label">申报编号:</div><div>{{dataEvaluationObj.applyNo}}</div>
          </div>
          <div class="div-first" style="height: 30px;line-height: 30px;">
          <div class="div-first-label">业务类型:</div><div>{{dataEvaluationObj.serviceName}}</div>
          </div>
          <div class="div-first" style="height: 30px;line-height: 30px;">
          <div class="div-first-label">受理单位:</div><div>{{dataEvaluationObj.fromPartyName}}</div>
          </div>
          </div>
          <div style="width: 90%;margin: 0 auto;margin-top: 10px; "  class="pjcontentcss">
            <div v-for="(item, index) in dataEvaluationObj.indexData" :key="item.eiId"  class="div-first">
              <div class="div-first-label">{{item.eiName}}:</div> <div  ><el-rate v-model="item.webScores" :max="5"></el-rate></div>
            </div>
            <div class="div-first">
            <div class="div-first-label" >评价描述:</div> <div>
            <el-input style="width: 300px"
            type="textarea"
            :rows="4"
            placeholder="请输入评价描述"
            v-model="message" maxlength="190">
          </el-input>
              <div v-if="qxAlertFlag" style="width:100%;margin: 0 auto;line-height: 30px;">
                <el-alert
                  :closable="false"
                  :title="alertMsg"
                  :type="alertType"
                  show-icon>
                </el-alert>
              </div>
            </div>
            </div>
          </div>
        </div>
        <div slot="footer" style="text-align: center;width: 100%;">
           <el-button @click="dialogVisible=false"  style="padding: 5px;font-size: 12px;width: 100px;height: 30px;"  >返回</el-button><el-button @click="submitData" :disabled="buttonShow"  type="primary" style="padding: 5px;font-size: 12px;width: 100px;height: 30px;"  >评价</el-button>
        </div>
      </el-dialog>
    </div>


    <div class="dialog_css12" v-if="dialogVisiblePj">
      <el-dialog
        :visible.sync="dialogVisiblePj"
        width="600px"
      >
        <div style="width: 100%;height: 20px;"></div>
        <div style="width: 80%;margin: 0 auto;font-size: 14px;margin-top: 5px;height: 30px;line-height: 30px;">办件服务评价详细：</div>
        <div style="width: 80%;margin: 0 auto;font-size: 14px;line-height: 30px;border: 1px solid  #dbdbdb;padding: 10px 0px;"  v-for="(item,index) in dataEvaluationList">
          <div style="width: 90%;margin: 0 auto;border-bottom: 1px solid #e6e6e6;padding-bottom: 5px;" >
            <div class="div-first" style="height: 30px;line-height: 30px;">
              <div class="div-first-label">申报编号:</div><div>{{item.applyNo}}</div>
            </div>
            <div class="div-first" style="height: 30px;line-height: 30px;">
              <div class="div-first-label">业务类型:</div><div>{{item.serviceName}}</div>
            </div>
            <div class="div-first" style="height: 30px;line-height: 30px;">
              <div class="div-first-label">受理单位:</div><div>{{item.fromPartyName}}</div>
            </div>
          </div>
          <div style="width: 90%;margin: 0 auto;margin-top: 10px;padding-bottom: 5px; "  class="pjcontentcss">
            <div v-for="(items, index) in item.indexData" :key="items.eiId"  class="div-first">
              <div class="div-first-label">{{items.eiName}}:</div> <div  ><el-rate v-model="items.scores" :max="5" disabled style="margin-top: 5px;" show-text :texts="['极差','一般','合格','满意','优秀']"></el-rate></div>
            </div>
            <div class="div-first">
              <div class="div-first-label" >评价描述:</div> <div  >
              {{item.peopleRemark}}
            </div>
            </div>
            <div class="div-first">
              <div class="div-first-label" >评价时间:</div> <div  >
              {{item.esTime}}
            </div>
            </div>
          </div>
          <div style="width: 90%;margin: 0 auto;margin-top: 10px;padding-bottom: 15px;padding-top: 5px;border-top: 1px solid #e6e6e6; "  class="pjcontentcss" v-if="item.esStatus==2">
            <div class="div-first">
              <div class="div-first-label" >回复单位:</div> <div  >
              {{item.fromPartyName}}
            </div>
            </div>
            <div class="div-first">
              <div class="div-first-label" >回复时间:</div> <div  >
              {{item.esReTime}}
            </div>
            </div>
            <div class="div-first">
              <div class="div-first-label" >回复内容:</div> <div  >
              {{item.esRemark}}
            </div>
            </div>
          </div>
        </div>
        <div slot="footer" style="text-align: center;width: 100%;">
          <el-button @click="dialogVisiblePj=false" type="primary"  style="padding: 5px;font-size: 12px;width: 100px;height: 30px;"  >返回</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>
    <table   width="80%" border="0" cellspacing="0" cellpadding="0" class="advice_tab_new" style="padding-top:15px;margin: 0 auto;" >
    <div style="line-height: 35px;padding-left: 300px" class="tccss">
     <!-- 低保申请申报详细弹出框-->
      <el-dialog  :visible.sync="blanApplyShow" width="900px" >
        <div>
          <a style="font-weight: 800">申办业务：</a><a>{{applyType}}</a>
        </div>
        <template>
          <el-tabs v-model="activeName3" type="border-card" @tab-click="handleClick">
            <el-tab-pane  label="申报概要"  name="first">
              <!--<tr>
                <td colspan="3"><h2 class="el-icon-tickets">办理方式信息展示</h2></td>
              </tr>-->
              <td colspan="2"><h2 class="information_tit">办理方式</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">区 划</td>
                  <td width="38%"> {{provinceName}}/{{cityName}}/{{areaName}}</td>
                  <td width="12%" class="grey">受理单位</td>
                  <td width="38%">{{blanApply.baseInfo.to_party_name}}</td>
                </tr>
                <tr>
                  <td width="12%" class="grey">办理方式</td>
                  <td width="38%">{{blanApply.baseInfo.apply_way_name}}</td>
                  <td width="12%" class="grey">申请人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.person_uid}}</td>
                  <td width="12%" class="grey">在享待遇</td>
                  <td width="38%">{{enjoy_treat}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">紧急联系人姓名</td>
                  <td width="37%">{{blanApply.baseInfo.emergency_name}}</td>
                  <td width="12%" class="grey">紧急联系人电话</td>
                  <td width="38%">{{blanApply.baseInfo.emergency_mobile}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">紧急联系人与申请人关系</td>
                  <td width="37%" colspan="3">{{blanApply.baseInfo.emergency_relation_name}}</td>
                </tr>
                <tr>
                  <td width="12%" class="grey" >申请原因</td>
                  <td width="38%" colspan="3">{{blanApply.baseInfo.req_reason}}</td>

                </tr>

              </table>
            </el-tab-pane>
            <el-tab-pane label="家庭信息" name="fors">
              <tr>
                <td colspan="5"><h2 class="information_tit">家庭信息</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">家庭成员人数</td>
                  <td width="37%">{{blanApply.familyInfo.family_person_count}}</td>
                  <td width="13%" class="grey">申请低保人数</td>
                  <td width="38%">{{blanApply.familyInfo.family_ensure_count}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">导致家庭贫困原因</td>
                  <td width="37%" >{{proverty_str}}</td>
                  <td width="13%" class="grey">希望得到哪些支持</td>
                  <td width="38%">
                    {{help_str}}
                  </td>
                </tr>
              </table>
              <tr>
                <td colspan="5"><h2 class="information_tit">住房情况</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">住房情况</td>
                  <td width="37%">{{blanApply.familyInfo.housing_info_name}}</td>
                  <td width="13%" class="grey">住房类别</td>
                  <td width="38%">{{blanApply.familyInfo.housing_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">住房面积</td>
                  <td width="37%">{{blanApply.familyInfo.housing_area}}</td>
                  <td width="13%" class="grey">租房费用</td>
                  <td width="38%">{{blanApply.familyInfo.housing_rent}}</td>
                </tr>
              </table>
              <tr>
                <td colspan="5"><h2 class="information_tit">家庭财产情况</h2></td>
              </tr>
                <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                  <tr>
                    <td width="13%" class="grey">家庭现实际月收入</td>
                    <td width="37%">{{blanApply.familyInfo.no_cut_family_income}}</td>
                    <td width="13%" class="grey">家庭存款</td>
                    <td width="38%">{{blanApply.familyInfo.deposit}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">冰 箱（台）</td>
                    <td width="37%">{{blanApply.familyInfo.property_frig}}</td>
                    <td width="13%" class="grey">空 调（台）</td>
                    <td width="38%">{{blanApply.familyInfo.property_air_conditioning}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">洗衣机（台）</td>
                    <td width="37%">{{blanApply.familyInfo.property_washing_machine}}</td>
                    <td width="13%" class="grey">手 机（台）</td>
                    <td width="38%">{{blanApply.familyInfo.property_phone}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">电 脑（台）</td>
                    <td width="37%">{{blanApply.familyInfo.property_computer}}</td>
                    <td width="13%" class="grey">电 视（台）</td>
                    <td width="38%">{{blanApply.familyInfo.property_television}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">其他家庭财产说明</td>
                    <td width="37%" colspan="3">{{blanApply.familyInfo.property_other}}</td>
                  </tr>
                </table>
            </el-tab-pane>
            <el-tab-pane label="户主信息" name="second">
              <td colspan="2"><h2 class="information_tit">基本信息</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">姓 名</td>
                  <td width="37%">{{blanApply.reqManInfo.person_name}}</td>
                  <td width="12%" class="grey">身份证号</td>
                  <td width="38%">{{blanApply.reqManInfo.person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">性 别</td>
                  <td width="37%" v-if="1==blanApply.reqManInfo.person_sex">男</td>
                  <td width="37%" v-else>女</td>
                  <td width="12%" class="grey">出生日期</td>
                  <td width="38%">{{birthday}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">年 龄</td>
                  <td width="38%">{{blanApply.reqManInfo.person_age}}</td>
                  <td width="12%" class="grey">民 族</td>
                  <td width="38%">{{blanApply.reqManInfo.nations_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="38%">{{blanApply.reqManInfo.relation_name}}</td>
                  <td width="12%" class="grey">婚姻状况</td>
                  <td width="38%">{{blanApply.reqManInfo.marriage_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">政治面貌</td>
                  <td width="38%">{{blanApply.reqManInfo.politics_name}}</td>
                  <td width="13%" class="grey">联系电话</td>
                  <td width="38%">{{blanApply.reqManInfo.mobile}}</td>

                <tr>
                <td width="13%" class="grey">文化程度</td>
                <td width="38%">{{blanApply.reqManInfo.culture_name}}</td>
                <td width="12%" class="grey">户口类型</td>
                <td width="38%">{{blanApply.reqManInfo.city_is_name}}</td>

                </tr>
                <tr>
                  <td width="13%" class="grey">户籍地址</td>
                  <td width="38%">{{blanApply.reqManInfo.regi_address}}</td>
                  <td width="12%" class="grey">居住地址</td>
                  <td width="38%">{{blanApply.reqManInfo.living_address}}</td>

                </tr>
                <tr>
                  <td width="13%" class="grey">是否优抚对象</td>
                  <td width="38%" v-if="0==blanApply.reqManInfo.gsc_is">否</td>
                  <td width="38%" v-else>是</td>
                  <td width="13%" class="grey">社会保障号</td>
                  <td width="38%">{{blanApply.reqManInfo.soical_ins_number}}</td>
                </tr>
              </table>
              <tr>
                <td colspan="3"><h2 class="information_tit">银行信息</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">银行类型</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_name}}</td>
                  <td width="12%" class="grey">银行卡类型</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_card_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">开户件类型</td>
                  <td width="37%">{{blanApply.reqManInfo.open_document_type_name}}</td>
                  <td width="12%" class="grey">银行卡号</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_account_code}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">银行户名</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_account_name}}</td>
                  <td width="13%" class="grey">开户身份证号</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="37%" >{{blanApply.reqManInfo.bank_relation_name}}</td>
                  <td width="13%" class="grey"></td>
                  <td width="37%" ></td>
                </tr>
              </table>
              <td colspan="2"><h2 class="information_tit">工作信息</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">劳动能力</td>
                  <td width="37%">{{blanApply.reqManInfo.work_capacity_name}}</td>
                  <td width="12%" class="grey">现工作单位</td>
                  <td width="38%">{{blanApply.reqManInfo.org_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">工作单位性质</td>
                  <td width="37%">{{blanApply.reqManInfo.org_nature_name}}</td>
                  <td width="12%" class="grey"></td>
                  <td width="38%"></td>
                </tr>
              </table>
              <td colspan="2"><h2 class="information_tit">健康信息</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">健康状况</td>
                  <td width="37%">{{blanApply.reqManInfo.health_name}}</td>
                  <td width="12%" class="grey">残疾证号</td>
                  <td width="38%">{{blanApply.reqManInfo.disability_number}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">残疾类型</td>
                  <td width="37%" colspan="3" v-if="disabilityList.length==0"></td>
                  <td width="37%" colspan="3" v-else>{{disabilityList}}</td>

                </tr>
                <tr>
                  <td width="13%" class="grey">疾病病种</td>
                  <td width="37%" colspan="3">{{blanApply.reqManInfo.serious_ill_name}}</td>

                </tr>
              </table>
              <td colspan="2"><h2 class="information_tit">收入情况</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">个人月总收入</td>
                  <td width="37%">{{blanApply.reqManInfo.income_total}}</td>
                  <td width="12%" class="grey">工 资</td>
                  <td width="38%">{{blanApply.reqManInfo.income_wages}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">退休金</td>
                  <td width="37%">{{blanApply.reqManInfo.income_pension}}</td>
                  <td width="12%" class="grey">零 工</td>
                  <td width="38%">{{blanApply.reqManInfo.income_odd_job}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">失业保险金</td>
                  <td width="37%">{{blanApply.reqManInfo.income_unemployment_insurance}}</td>
                  <td width="12%" class="grey">租 金</td>
                  <td width="38%">{{blanApply.reqManInfo.income_rent}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">经营收入</td>
                  <td width="37%">{{blanApply.reqManInfo.income_operating}}</td>
                  <td width="12%" class="grey">赡养费</td>
                  <td width="38%">{{blanApply.reqManInfo.income_alimony}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">抚养费</td>
                  <td width="37%">{{blanApply.reqManInfo.income_raise}}</td>
                  <td width="12%" class="grey">其 他</td>
                  <td width="38%">{{blanApply.reqManInfo.income_other}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">备 注</td>
                  <td width="37%" colspan="3">{{blanApply.reqManInfo.remark}}</td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="家庭成员信息" name="five">
              <tr>
                <td colspan="5"><h2 class="information_tit">家庭成员信息</h2></td>
              </tr>
              <table  width="90%" border="0" cellspacing="1" cellpadding="0" class="enjoy_tab" >

                <tr >
                  <td width="25%">姓名</td>
                  <td width="25%">身份证号</td>
                  <td width="25%">与户主关系</td>
                  <td width="25%">操作</td>
                </tr>
                <tr v-for="(member,index) in blanApply.members" :key="index" >
                  <td>{{member.person_name}}</td>
                  <td>{{member.person_uid}}</td>
                  <td>{{member.relation_name}}</td>
                  <td class="member_sign" >
                    <a   href="javascript:void(0)" @click="showMember(member,index)"><img src="../../../static/images/personal_sign3.png"> 查看</a>
                  </td>
                </tr>

              </table>
            </el-tab-pane>
            <el-tab-pane label="申报材料" name="third">
              <td colspan="2"><h2 class="information_tit">上传图片一览</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr><td>
                  <div   v-for="(photo,index) in UploadTypeList"  :key="index+'fjfj'">
                    <div style="line-height: 27px;margin-bottom: 5px ;font-size: 14px;padding-left: 5px;    font-weight: 600;
      background-color: #f2f3f5;">» {{photo.oneTypeName}}</div>
                    <div  v-for="(two,indexs) in photo.childData"     :key="indexs+'sdsd'" style="display:flex;align-content: left;margin-top: 10px;margin-bottom: 10px;">
                      <div style="width:150px;padding-left: 20px;">
                        {{two.twoTypeName}}</div>
                      <!--<el-form-item   prop="two.twoAttachIdArr" :rules="[{required: photo.oneTypeCode=='FJ_1_ATTORNEY'?(blanApply.baseInfo.apply_way=='1'?true:false):(photo.oneNotNull=='1'?true:false), message: '请上传'+two.twoTypeName ,tigger:'blur'}]">-->
                      <div style="width:100%;text-align: right;" >
                        <!--<ImgUploaderOneTitle-->
                        <!--:file-type="two.twoTypeCode"-->
                        <!--:canEdit="canEditBoolean"-->
                        <!--:maxCount="1"-->
                        <!--v-model="two.twoAttachIdArr"-->
                        <!--/>-->
                        <img   :src="getImg(two.twoAttachId)" style="width: 180px;height: 150px;" v-if="two.twoAttachId!='' &&two.twoAttachId!='-1'"/>
                        <div style="width: 180px;height: 150px;line-height: 150px;background-color: #e8e8e8;text-align: center;float: right;" v-if="two.twoAttachId=='' ||two.twoAttachId=='-1'">--未上传--</div>

                      </div>
                    </div>
                    <!--</el-form-item>-->
                  </div>
                </td></tr>
                <!--<tr  v-for="(photo,index) in blanphotos"  :key="index">-->
                  <!--<td width="20%" align="left" style="padding-left: 1%;">{{photo.name}}：</td>-->
                  <!--<td  style="padding-left: 10px;padding-top: 5px;padding-bottom: 5px;">-->
                    <!--&lt;!&ndash;                    <img src="photo.photos" :file-type="photo.type" :limit="photo.limit" v-model="photo.photos"/>&ndash;&gt;-->
                    <!--<img v-for="pp in photo.photos" :src="getImg(pp)" style="width: 180px;height: 150px;"/>-->
                  <!--</td>-->
                <!--</tr>-->
              </table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-dialog>
      <!--申请人家庭信息详细-->
      <el-dialog  :visible.sync="familyUserDialog" width="900px" >

        <tr>
          <td colspan="5"><h2 class="information_tit">家庭成员详细</h2></td>
        </tr>
        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

          <tr>
            <td width="13%" class="grey">姓 名</td>
            <td width="37%">{{famlyPeopleOne.person_name}}</td>
            <td width="12%" class="grey">身份证号</td>
            <td width="38%">{{famlyPeopleOne.person_uid}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">性 别</td>
            <td width="37%" v-if="1==famlyPeopleOne.person_sex">男</td>
            <td width="37%" v-else>女</td>
            <td width="12%" class="grey">出生日期</td>
            <td width="38%">{{famlyBirthday}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">年 龄</td>
            <td width="37%">{{famlyPeopleOne.person_age}}</td>
            <td width="12%" class="grey">民 族</td>
            <td width="38%">{{famlyPeopleOne.nations_type_name}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">与申请人关系</td>
            <td width="37%">{{famlyPeopleOne.relation_name}}</td>
            <td width="12%" class="grey">婚姻状况</td>
            <td width="38%">{{famlyPeopleOne.marriage_name}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">政治面貌</td>
            <td width="37%">{{famlyPeopleOne.politics_name}}</td>
            <td width="12%" class="grey">户口类型</td>
            <td width="38%">{{famlyPeopleOne.city_is_name}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">文化程度</td>
            <td width="37%">{{famlyPeopleOne.culture_name}}</td>
            <td width="13%" class="grey">是否优抚对象</td>
            <td width="38%" v-if="0==famlyPeopleOne.gsc_is">否</td>
            <td width="38%" v-else>是</td>
          </tr>
          <tr>

            <td width="12%" class="grey">社会保障号</td>
            <td width="38%">{{famlyPeopleOne.soical_ins_number}}</td>
            <td width="12%" class="grey"></td>
            <td width="38%"></td>
          </tr>
          <tr >
            <td colspan="5" align="center" >
              <div style="display: flex;justify-content: center;width: 100%;">
                <div style="width: 180px;height: 127px;margin-right: 20px;">
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture"
                    action=""
                    :file-list="fmfrontFileList"
                    :show-file-list="false"

                  >
                    <img v-if="blanApply.currMember.idcard_pic_front_img" :src="blanApply.currMember.idcard_pic_front_img" class="avatar" style="width:180px;height: 127px;">
                    <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;">
                  </el-upload>
                </div>
                <div style="width: 180px;height: 127px;">
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture"
                    action=""
                    :file-list="fmbackFileList"
                    :show-file-list="false"

                  >
                    <img v-if="blanApply.currMember.idcard_pic_back_img" :src="blanApply.currMember.idcard_pic_back_img" class="avatar" style="width:180px;height: 127px;">
                    <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                  </el-upload>
                </div>
              </div>
              <div v-if="qxAlertFlag" style="width:380px;margin: 0 auto;line-height: 30px;margin-top: 10px;">
                <el-alert
                  :closable="false"
                  :title="alertMsg"
                  :type="alertType"
                  show-icon>
                </el-alert>
              </div>
            </td>
          </tr>
        </table>


        <tr>
          <td colspan="5"><h2 class="information_tit">工作信息</h2></td>
        </tr>
        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

          <tr>
            <td width="13%" class="grey">劳动能力</td>
            <td width="37%">{{famlyPeopleOne.work_capacity_name}}</td>
            <td width="12%" class="grey">现工作单位</td>
            <td width="38%">{{famlyPeopleOne.org_name}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">工作单位性质</td>
            <td width="37%">{{famlyPeopleOne.org_nature_name}}</td>
            <td width="12%" class="grey"></td>
            <td width="38%"></td>
          </tr>
        </table>

        <tr>
          <td colspan="5"><h2 class="information_tit">健康信息</h2></td>
        </tr>
        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

          <tr>
            <td width="13%" class="grey">健康状况</td>
            <td width="37%">{{famlyPeopleOne.health_name}}</td>
            <td width="12%" class="grey">残疾证号</td>
            <td width="38%">{{famlyPeopleOne.disability_number}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">残疾类型</td>
            <td width="37%" colspan="3" v-if="famlyPeopleOne.length==0"></td>
            <td width="37%" colspan="3" v-else>{{disabilityList2}}</td>

          </tr>
          <tr>
            <td width="13%" class="grey">疾病病种</td>
            <td width="37%" colspan="3">{{famlyPeopleOne.serious_ill_name}}</td>

          </tr>
        </table>
        <tr>
          <td colspan="5"><h2 class="information_tit">收入情况</h2></td>
        </tr>
        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
          <tr>
            <td width="13%" class="grey">个人月总收入</td>
            <td width="37%">{{famlyPeopleOne.income_total}}</td>
            <td width="12%" class="grey">工 资</td>
            <td width="38%">{{famlyPeopleOne.income_wages}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">退休金</td>
            <td width="37%">{{famlyPeopleOne.income_pension}}</td>
            <td width="12%" class="grey">零 工</td>
            <td width="38%">{{famlyPeopleOne.income_odd_job}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">失业保险金</td>
            <td width="37%">{{famlyPeopleOne.income_unemployment_insurance}}</td>
            <td width="12%" class="grey"> 租 金</td>
            <td width="38%">{{famlyPeopleOne.income_rent}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">经营收入</td>
            <td width="37%">{{famlyPeopleOne.income_operating}}</td>
            <td width="12%" class="grey"> 赡养费</td>
            <td width="38%">{{famlyPeopleOne.income_alimony}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">抚养费</td>
            <td width="37%">{{famlyPeopleOne.income_raise}}</td>
            <td width="12%" class="grey">  其 他</td>
            <td width="38%">{{famlyPeopleOne.income_other}}</td>
          </tr>
          <tr>
            <td width="13%" class="grey">备 注</td>
            <td width="37%" colspan="3">{{famlyPeopleOne.remark}}</td>

          </tr>
        </table>
      </el-dialog>
      <!--综合弹出，接地除外-->
      <el-dialog  :visible.sync="clpApplyShow" width="900px" >
        <div>
          <a style="font-weight: 800">申办业务：</a><a>{{applyType}}</a>
        </div>
        <template>
          <el-tabs v-model="activeName3" type="border-card" @tab-click="handleClick">
            <el-tab-pane  v-if=" blanApply.baseInfo.apply_way!=1"label="申报概要"  name="first">
              <td colspan="2"><h2 class="information_tit">办理方式</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">办理方式</td>
                  <td width="38%">{{blanApply.baseInfo.apply_way_name}}</td>
                  <td width="12%" class="grey">申请人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.person_uid}}</td>
                  <td width="12%" class="grey">受理单位</td>
                  <td width="38%">{{blanApply.reqManInfo.party_name}}</td>
                </tr>
                <tr>
                  <td width="12%" class="grey">在享待遇</td>
                  <td width="38%">{{enjoy_treat}}</td>
                  <td width="12%" class="grey"></td>
                  <td width="38%"></td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane  v-if=" blanApply.baseInfo.apply_way==1" label="申报概要"  name="first">
              <td colspan="2"><h2 class="information_tit">办理方式</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">办理方式</td>
                  <td width="38%">{{blanApply.baseInfo.apply_way_name}}</td>
                  <td width="12%" class="grey">申请人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.person_uid}}</td>
                  <td width="12%" class="grey">委托人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.auth_person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">委托人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.auth_person_uid}}</td>
                  <td width="12%" class="grey">委托人电话</td>
                  <td width="38%">{{blanApply.baseInfo.auth_tel}}</td>
                </tr>

                <tr>
                  <td width="12%" class="grey">受理单位</td>
                  <td width="38%" >{{blanApply.reqManInfo.party_name}}</td>
                  <td width="12%" class="grey">在享待遇</td>
                  <td width="38%">{{enjoy_treat}}</td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="申请信息" name="second">
              <td colspan="2"><h2 class="information_tit">基本信息</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">姓 名</td>
                  <td width="37%">{{blanApply.reqManInfo.person_name}}</td>
                  <td width="12%" class="grey">身份证号</td>
                  <td width="38%">{{blanApply.reqManInfo.person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">性 别</td>
                  <td width="37%" v-if="1==blanApply.reqManInfo.person_sex">男</td>
                  <td width="37%" v-else>女</td>
                  <td width="12%" class="grey">出生日期</td>
                  <td width="38%">{{birthday}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">年 龄</td>
                  <td width="38%">{{blanApply.reqManInfo.person_age}}</td>
                  <td width="12%" class="grey">民 族</td>
                  <td width="38%">{{blanApply.reqManInfo.nations_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">联系电话</td>
                  <td width="38%">{{blanApply.reqManInfo.mobile}}</td>
                  <td width="12%" class="grey">户口类型</td>
                  <td width="38%">{{blanApply.reqManInfo.city_is_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">户籍地址</td>
                  <td width="38%">{{blanApply.reqManInfo.regi_address}}</td>
                  <td width="12%" class="grey">居住地址</td>
                  <td width="38%">{{blanApply.reqManInfo.living_address}}</td>
                </tr>
           <!--     <tr>
                  <td width="13%" class="grey">是否低保</td>
                  <td width="38%" v-if="1==blanApply.reqManInfo.is_blan">是</td>
                  <td width="38%" v-else>否</td>
                  <td width="12%" class="grey">低保类别</td>
                  <td width="38%" v-if="1==blanApply.reqManInfo.is_blan">{{blanApply.reqManInfo.blan_type_name}}</td>
                  <td width="38%" v-else></td>
                </tr>-->
                <tr>
                 <!-- <td width="13%" class="grey">社会保障号</td>
                  <td width="38%">{{blanApply.reqManInfo.soical_ins_number}}</td>-->
                  <td width="13%" class="grey">是否有监护人</td>
                  <td width="38%" v-if="1==blanApply.reqManInfo.is_guardian_person">有</td>
                  <td width="38%" v-else>无</td>

                  <td v-if="fmFlag" width="13%" class="grey"><!--单亲状态--></td>
                  <td v-if="fmFlag" width="37%"><!--{{blanApply.reqManInfo.is_single_name}}--></td>

                </tr>

                <tr>
                  <td width="12%" class="grey" >申请原因</td>
                  <td width="38%" colspan="3">{{blanApply.baseInfo.req_reason}}</td>
                </tr>
              </table>
              <div v-if="fmFlag">

                  <td colspan="2"><h2 class="information_tit">家庭信息</h2></td>
                  <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                    <tr>
                      <td width="13%" class="grey">父亲信息</td>
                      <td width="37%" v-if="blanApply.reqManInfo.is_father_single==0">有</td>
                      <td width="37%" v-else>无</td>
                      <td width="12%" class="grey">母亲信息</td>
                      <td width="37%" v-if="blanApply.reqManInfo.is_mother_single==0">有</td>
                      <td width="37%" v-else>无</td>
                    </tr>
                  </table>


               <!-- //父亲信息-->
                <div v-if="blanApply.reqManInfo.is_father_single===0">
                <td colspan="2"><h2 class="information_tit">父亲信息</h2></td>
                <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                  <tr>
                    <td width="13%" class="grey">父亲状态</td>
                    <td width="37%">{{blanApply.reqManInfo.father_status_name}}</td>
                    <td width="12%" class="grey">父亲姓名</td>
                    <td width="38%">{{blanApply.reqManInfo.father_name}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">父亲手机号</td>
                    <td width="37%">{{blanApply.reqManInfo.father_tel}}</td>
                    <td width="12%" class="grey">父亲户籍地址</td>
                    <td width="38%">{{blanApply.reqManInfo.father_reg_address}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">父亲居住地址</td>
                    <td width="37%">{{blanApply.reqManInfo.father_address}}</td>
                    <td width="12%" class="grey">父亲证件号</td>
                    <td width="38%">{{blanApply.reqManInfo.father_cred_code}}</td>
                  </tr>
                  <tr>
                    <td width="13%" class="grey">父亲健康状态</td>
                    <td width="37%">{{blanApply.reqManInfo.father_health_name}}</td>
                    <td width="12%" class="grey">是否监护人</td>
                    <td width="38%" v-if="blanApply.reqManInfo.is_guardian_father=='0'">否</td>
                    <td width="38%" v-else-if="blanApply.reqManInfo.is_guardian_father=='1'">是</td>
                   <!-- <td width="13%" class="grey">父亲家庭经济来源</td>
                    <td width="37%">{{blanApply.reqManInfo.father_income_name}}</td>-->
                  </tr>
                </table>
                </div>
<!--                母亲信息-->
                <div v-if=" blanApply.reqManInfo.is_mother_single===0">
                  <td colspan="2"><h2 class="information_tit">母亲信息</h2></td>
                  <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                    <tr>
                      <td width="13%" class="grey">母亲状态</td>
                      <td width="37%">{{blanApply.reqManInfo.mother_status_name}}</td>
                      <td width="12%" class="grey">母亲姓名</td>
                      <td width="38%">{{blanApply.reqManInfo.mother_name}}</td>
                    </tr>
                    <tr>
                      <td width="13%" class="grey">母亲手机号</td>
                      <td width="37%">{{blanApply.reqManInfo.mother_tel}}</td>
                      <td width="12%" class="grey">母亲户籍地址</td>
                      <td width="38%">{{blanApply.reqManInfo.mother_reg_address}}</td>
                    </tr>
                    <tr>
                      <td width="13%" class="grey">母亲居住地址</td>
                      <td width="37%">{{blanApply.reqManInfo.mother_address}}</td>
                      <td width="12%" class="grey">母亲证件号</td>
                      <td width="38%">{{blanApply.reqManInfo.mother_cred_code}}</td>
                    </tr>
                    <tr>
                      <td width="13%" class="grey">母亲健康状态</td>
                      <td width="37%">{{blanApply.reqManInfo.mother_health_name}}</td>
                      <td width="12%" class="grey">是否监护人</td>
                      <td width="38%" v-if="blanApply.reqManInfo.is_guardian_mother=='0'">否</td>
                      <td width="38%" v-else-if="blanApply.reqManInfo.is_guardian_mother=='1'">是</td>
           <!--           <td width="13%" class="grey">母亲家庭经济来源</td>
                      <td width="37%">{{blanApply.reqManInfo.mother_income_name}}</td>-->
                    </tr>

                  </table>
                </div>
              </div>

              <td colspan="2"><h2 class="information_tit">健康信息</h2></td>
              <table  width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey" >健康状况</td>
                  <td width="38%" >{{blanApply.reqManInfo.health_name}}</td>
                  <td width="13%" class="grey"></td>
                  <td width="37%" ></td>
                </tr>
              </table>
              <div v-if="blanApply.reqManInfo.health_name=='残疾'">
                <td colspan="2"><h2 class="information_tit">残疾证信息</h2></td>
                <table  width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                  <tr>
                    <td width="12%" class="grey" >颁发日期</td>
                    <td width="38%" >{{blanApply.reqManInfo.dis_apply_time}}</td>
                    <td width="13%" class="grey">失效日期</td>
                    <td width="37%" >{{blanApply.reqManInfo.dis_invalid_time}}</td>
                  </tr>
                  <tr>
                    <!--<td width="13%" class="grey">自理能力</td>
                    <td width="37%" v-if="''==blanApply.reqManInfo.viability_name">无</td>
                    <td width="37%" v-else>{{blanApply.reqManInfo.viability_name}}</td>-->
                    <td width="12%" class="grey" >残疾证号</td>
                    <td width="38%" >{{blanApply.reqManInfo.disability_number}}</td>
                    <td width="13%" class="grey">残疾类型</td>
                    <td width="37%" v-if="disabilityList.length==0"></td>
                    <td width="37%"  v-else>{{disabilityList}}</td>
                  </tr>
                </table>
              </div>
              <div v-else-if="blanApply.reqManInfo.health_name=='健康'">
               <table  width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
               </table>
             </div>
              <div v-else>
                <td colspan="2"><h2 class="information_tit">健康状况描述</h2></td>
                <table  width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                  <tr>
                    <td width="11%" class="grey" >健康状况描述</td>
                    <td width="80%" colspan="3">{{blanApply.reqManInfo.health_info}}</td>
                  </tr>
                </table>
              </div>

              <tr>
                <td colspan="3"><h2 class="information_tit">是否集中供养</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <td width="12%" class="grey" >是否集中供养</td>
                <td width="38%" v-if="blanApply.reqManInfo.centralized==0">是</td>
                <td width="38%" v-else-if="blanApply.reqManInfo.centralized==1">否</td>
                <td width="13%" class="grey"></td>
                <td width="37%" ></td>
              </table>
              <div v-if="blanApply.reqManInfo.centralized===0">
                <tr>
                  <td colspan="3"><h2 class="information_tit">集中供养信息</h2></td>
                </tr>
                <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                  <tr>
                     <td width="12%" class="grey" >入住福利机构</td>
                     <td width="38%" >{{blanApply.reqManInfo.centralized_type_name}}</td>
                     <td width="13%" class="grey">入驻日期</td>
                     <td width="37%" >{{blanApply.reqManInfo.centralized_time}}</td>
                  </tr>
                  <tr>
                    <td width="12%" class="grey" >福利证号</td>
                    <td width="38%" >{{blanApply.reqManInfo.centralized_code}}</td>
                    <td width="13%" class="grey"></td>
                    <td width="37%" ></td>
                  </tr>
                </table>
              </div>
              <tr>
                <td colspan="3"><h2 class="information_tit">银行信息</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">卡类型</td>
                  <td width="37%">{{blanApply.reqManInfo.sbk_type_name}}</td>
                  <td width="13%" class="grey">开户银行</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_name}}</td>

                </tr>
                <tr>
                  <td width="12%" class="grey">银行卡类型</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_card_type_name}}</td>
                  <td width="13%" class="grey">开户件类型</td>
                  <td width="37%">{{blanApply.reqManInfo.open_document_type_name}}</td>

                </tr>
                <tr>
                  <td width="12%" class="grey">银行卡号</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_account_code}}</td>
                  <td width="13%" class="grey">开户户名</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_account_name}}</td>

                </tr>

                <tr>
                  <td width="13%" class="grey">开户身份证号</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_person_uid}}</td>

                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="37%" >{{blanApply.reqManInfo.bank_relation_name}}</td>
                </tr>
              </table>
              <tr>
                <td colspan="3"><h2 class="information_tit">紧急联系人信息</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">紧急联系人姓名</td>
                  <td width="37%">{{blanApply.baseInfo.emergency_name}}</td>
                  <td width="12%" class="grey">紧急联系人电话</td>
                  <td width="38%">{{blanApply.baseInfo.emergency_mobile}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">紧急联系人与申请人关系</td>
                  <td width="37%" colspan="3">{{blanApply.baseInfo.emergency_relation_name}}</td>
                </tr>
              </table>
              <tr v-if="1==blanApply.reqManInfo.is_guardian_person">
                <td colspan="3"><h2 class="information_tit">监护人信息</h2></td>
              </tr>
              <table v-if="1==blanApply.reqManInfo.is_guardian_person" width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="37%">{{blanApply.reqManInfo.guardian_reqman_relation_name}}</td>
                  <td width="12%" class="grey">监护人姓名</td>
                  <td width="38%">{{blanApply.reqManInfo.guardian_person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">监护人身份证</td>
                  <td width="37%">{{blanApply.reqManInfo.guardian_person_uid}}</td>
                  <td width="15%" class="grey">监护人联系电话</td>
                  <td width="35%">{{blanApply.reqManInfo.guardian_phone}}</td>
                </tr>
              </table>

            </el-tab-pane>
            <el-tab-pane label="申报材料" name="third">
              <td colspan="2"><h2 class="information_tit">上传图片一览</h2></td>

              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
              <!--  <tr>
                  <td width="120px"  style="">身份证人像面、国徽面：
                  <td  style="padding-left: 10px;padding-top: 5px;padding-bottom: 5px;">
                    <span class="title"> &nbsp; &nbsp;</span>
                    <em v-if="blanApply.baseInfo.apply_way==1" style="display: flex;justify-content: left;margin-top: -20px">
                      <div style="width: 190px;">
                        <el-upload
                          class="avatar-uploader"
                          list-type="picture"
                          action=""
                          :file-list="frontFileList"
                          :show-file-list="false"
                        >
                          <img v-if="idcard_pic_front_img" :src="idcard_pic_front_img" class="avatar" style="width:180px;height: 127px;">
                          <img  v-else src="../../../static/images/id_front.png" style="width: 180px;height: 127px;padding-right: 10px;">
                        </el-upload>
                      </div>
                      <div style="width: 190px;">
                        <el-upload
                          class="avatar-uploader"
                          list-type="picture"
                          action=""
                          :file-list="backFileList"
                          :show-file-list="false"
                        >
                          <img v-if="idcard_pic_back_img" :src="idcard_pic_back_img" class="avatar" style="width:180px;height: 127px;padding-right: 10px;">
                          <img v-else src="../../../static/images/id_back.png" style="width: 180px;height: 127px;">
                        </el-upload>
                      </div>
                    </em>
                  </td>
                </tr>-->
                <!--<tr  v-for="(photo,index) in UploadTypeList"  :key="index">-->
                  <!--<td width="20%" align="left" style="padding-left: 1%;">{{photo.name}}：</td>-->
                  <!--<td  style="padding-left: 10px;padding-top: 5px;padding-bottom: 5px;">-->
<!--&lt;!&ndash;                    <img src="photo.photos" :file-type="photo.type" :limit="photo.limit" v-model="photo.photos"/>&ndash;&gt;-->
                    <!--<img v-for="pp in photo.photos" :src="getImg(pp)" style="width: 180px;height: 150px;"/>-->
                  <!--</td>-->
                <!--</tr>-->
                <tr><td>
                  <div   v-for="(photo,index) in UploadTypeList"  :key="index+'fjfj'">
                    <div v-if="!(blanApply.baseInfo.apply_way =='0' && photo.oneTypeCode=='FJ_1_ATTORNEY')" style="width: 100%">
                    <div style="line-height: 27px;margin-bottom: 5px ;font-size: 14px;padding-left: 5px;    font-weight: 600;
      background-color: #f2f3f5;">» {{photo.oneTypeName}}</div>
                    <div  v-for="(two,indexs) in photo.childData"     :key="indexs+'sdsd'" style="display:flex;align-content: left;margin-top: 10px;margin-bottom: 10px;">
                      <div style="width:150px;padding-left: 20px;">
                        {{two.twoTypeName}}</div>
                      <!--<el-form-item   prop="two.twoAttachIdArr" :rules="[{required: photo.oneTypeCode=='FJ_1_ATTORNEY'?(blanApply.baseInfo.apply_way=='1'?true:false):(photo.oneNotNull=='1'?true:false), message: '请上传'+two.twoTypeName ,tigger:'blur'}]">-->
                      <div style="width:100%;text-align: right;" >
                        <!--<ImgUploaderOneTitle-->
                        <!--:file-type="two.twoTypeCode"-->
                        <!--:canEdit="canEditBoolean"-->
                        <!--:maxCount="1"-->
                        <!--v-model="two.twoAttachIdArr"-->
                        <!--/>-->
                        <img   :src="getImg(two.twoAttachId)" style="width: 180px;height: 150px;" v-if="two.twoAttachId!='' &&two.twoAttachId!='-1'"/>
                        <div style="width: 180px;height: 150px;line-height: 150px;background-color: #e8e8e8;text-align: center;float: right;" v-if="two.twoAttachId=='' ||two.twoAttachId=='-1'">--未上传--</div>
                      </div>
                      </div>
                    </div>
                    <!--</el-form-item>-->
                  </div>
                </td></tr>
              </table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-dialog>
      <!--jdst-->
      <el-dialog  :visible.sync="tyApplyShow" width="900px" >
        <div>
          <a style="font-weight: 800">申办业务：</a><a>{{applyType}}</a>
        </div>
        <template>
          <el-tabs v-model="activeName3" type="border-card" @tab-click="handleClick">
            <el-tab-pane  v-if=" blanApply.baseInfo.apply_way!=1 && archive_type_code!=='JDST'"label="申报概要"  name="first">
              <td colspan="2"><h2 class="information_tit">办理方式</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">办理方式</td>
                  <td width="38%">{{blanApply.baseInfo.apply_way_name}}</td>
                  <td width="12%" class="grey">申请人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.person_uid}}</td>
                  <td width="12%" class="grey">受理单位</td>
                  <td width="38%">{{blanApply.reqManInfo.party_name}}</td>
                </tr>
                <tr>
                  <td width="12%" class="grey">在享待遇</td>
                  <td width="38%">{{enjoy_treat}}</td>
                  <td width="12%" class="grey"></td>
                  <td width="38%"></td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane  v-if=" blanApply.baseInfo.apply_way==1 && archive_type_code!=='JDST'" label="申报概要"  name="first">

              <td colspan="2"><h2 class="information_tit">办理方式</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">办理方式</td>
                  <td width="38%">{{blanApply.baseInfo.apply_way_name}}</td>
                  <td width="12%" class="grey">申请人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.person_uid}}</td>
                  <td width="12%" class="grey">委托人姓名</td>
                  <td width="38%">{{blanApply.baseInfo.auth_person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">委托人身份证</td>
                  <td width="37%">{{blanApply.baseInfo.auth_person_uid}}</td>
                  <td width="12%" class="grey">委托人电话</td>
                  <td width="38%">{{blanApply.baseInfo.auth_tel}}</td>
                </tr>

                <tr>
                  <td width="12%" class="grey">受理单位</td>
                  <td width="38%" >{{blanApply.reqManInfo.party_name}}</td>
                  <td width="12%" class="grey">在享待遇</td>
                  <td width="38%">{{enjoy_treat}}</td>
                </tr>
              </table>
            </el-tab-pane>
            <!--节地生态葬申报概要-->
            <el-tab-pane  v-if=" archive_type_code=='JDST'" label="申报概要"  name="first">
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="12%" class="grey">管理单位</td>
                  <td width="38%" >{{blanApply.reqManInfo.party_name}}</td>
                  <td width="14%" class="grey"></td>
                  <td width="38%"></td>
                </tr>
                <tr>
                  <td width="13%" class="grey">申请人姓名</td>
                  <td width="37%">{{blanApply.reqManInfo.req_person_name}}</td>
                  <td width="14%" class="grey">申请人身份证号</td>
                  <td width="38%">{{blanApply.reqManInfo.req_person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">联系电话</td>
                  <td width="38%">{{blanApply.reqManInfo.req_tel}}</td>
                  <td width="13%" class="grey">居住地址</td>
                  <td width="38%">{{blanApply.reqManInfo.req_addr}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">与逝者关系</td>
                  <td width="37%"  >{{blanApply.reqManInfo.req_relation_name}}</td>
                  <td width="13%" class="grey"></td>
                  <td width="38%"></td>
                </tr>

              </table>
            </el-tab-pane>

            <el-tab-pane label="申请信息" name="second" >
              <td colspan="2"  v-if=" archive_type_code !='JDST'"><h2 class="information_tit">基本信息</h2></td>
              <table  v-if=" archive_type_code !='JDST'" width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">姓 名</td>
                  <td width="37%">{{blanApply.reqManInfo.person_name}}</td>
                  <td width="12%" class="grey">身份证号</td>
                  <td width="38%">{{blanApply.reqManInfo.person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">性 别</td>
                  <td width="37%" v-if="1==blanApply.reqManInfo.person_sex">男</td>
                  <td width="37%" v-else>女</td>
                  <td width="12%" class="grey">出生日期</td>
                  <td width="38%">{{birthday}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">年 龄</td>
                  <td width="38%">{{blanApply.reqManInfo.person_age}}</td>
                  <td width="12%" class="grey">民 族</td>
                  <td width="38%">{{blanApply.reqManInfo.nations_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">联系电话</td>
                  <td width="38%">{{blanApply.reqManInfo.mobile}}</td>
                  <td width="12%" class="grey">户口类型</td>
                  <td width="38%">{{blanApply.reqManInfo.city_is_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">户籍地址</td>
                  <td width="38%">{{blanApply.reqManInfo.regi_address}}</td>
                  <td width="12%" class="grey">居住地址</td>
                  <td width="38%">{{blanApply.reqManInfo.living_address}}</td>
                </tr>
                <!--     <tr>
                       <td width="13%" class="grey">是否低保</td>
                       <td width="38%" v-if="1==blanApply.reqManInfo.is_blan">是</td>
                       <td width="38%" v-else>否</td>
                       <td width="12%" class="grey">低保类别</td>
                       <td width="38%" v-if="1==blanApply.reqManInfo.is_blan">{{blanApply.reqManInfo.blan_type_name}}</td>
                       <td width="38%" v-else></td>
                     </tr>-->
                <tr>
                  <td width="12%" class="grey" >申请原因</td>
                  <td width="38%" colspan="3">{{blanApply.baseInfo.req_reason}}</td>
                </tr>
              </table>

              <td colspan="2"  v-if=" archive_type_code !='JDST' && 1==blanApply.reqManInfo.is_guardian_person"><h2 class="information_tit">监护人信息</h2></td>
              <table v-if="archive_type_code !='JDST' && 1==blanApply.reqManInfo.is_guardian_person" width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="37%">{{blanApply.reqManInfo.guardian_reqman_relation_name}}</td>
                  <td width="12%" class="grey">监护人姓名</td>
                  <td width="38%">{{blanApply.reqManInfo.guardian_person_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">监护人身份证</td>
                  <td width="37%">{{blanApply.reqManInfo.guardian_person_uid}}</td>
                  <td width="15%" class="grey">监护人联系电话</td>
                  <td width="35%">{{blanApply.reqManInfo.guardian_phone}}</td>
                </tr>
              </table>
              <td colspan="2" v-if="archive_type_code=='JDST'"><h2 class="information_tit">安葬奖补信息</h2></td>
              <table v-if="archive_type_code=='JDST'" width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">逝者姓名</td>
                  <td width="37%">{{blanApply.reqManInfo.person_name}}</td>
                  <td width="12%" class="grey">逝者身份证号</td>
                  <td width="38%">{{blanApply.reqManInfo.person_uid}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">对象类别</td>
                  <td width="38%">{{blanApply.reqManInfo.person_class_name}}</td>
                  <td width="13%" class="grey">安葬类型</td>
                  <td width="38%">{{blanApply.reqManInfo.person_type_name}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">户籍地址</td>
                  <td width="38%">{{blanApply.reqManInfo.regi_address}}</td>
                  <td width="12%" class="grey">居住地址</td>
                  <td width="38%">{{blanApply.reqManInfo.living_address}}</td>
                </tr>
              </table>
              <tr>
                <td colspan="3"><h2 class="information_tit">银行信息</h2></td>
              </tr>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                <tr>
                  <td width="13%" class="grey">卡类型</td>
                  <td width="37%">{{blanApply.reqManInfo.sbk_type_name}}</td>
                  <td width="13%" class="grey">开户银行</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_name}}</td>

                </tr>
                <tr>
                  <td width="12%" class="grey">银行卡类型</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_card_type_name}}</td>
                  <td width="13%" class="grey">开户件类型</td>
                  <td width="37%">{{blanApply.reqManInfo.open_document_type_name}}</td>

                </tr>
                <tr>
                  <td width="12%" class="grey">银行卡号</td>
                  <td width="38%">{{blanApply.reqManInfo.bank_account_code}}</td>
                  <td width="13%" class="grey">开户户名</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_account_name}}</td>

                </tr>
                <tr>
                  <td width="13%" class="grey">开户身份证号</td>
                  <td width="37%">{{blanApply.reqManInfo.bank_person_uid}}</td>
                  <td width="13%" class="grey">与申请人关系</td>
                  <td width="37%" >{{blanApply.reqManInfo.bank_relation_name}}</td>

                </tr>
              </table>
              <tr v-if="archive_type_code!=='JDST'">
                <td colspan="3"><h2 class="information_tit">紧急联系人信息</h2></td>
              </tr>
              <table v-if="archive_type_code!=='JDST'" width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr>
                  <td width="13%" class="grey">紧急联系人姓名</td>
                  <td width="37%">{{blanApply.baseInfo.emergency_name}}</td>
                  <td width="12%" class="grey">紧急联系人电话</td>
                  <td width="38%">{{blanApply.baseInfo.emergency_mobile}}</td>
                </tr>
                <tr>
                  <td width="13%" class="grey">紧急联系人与申请人关系</td>
                  <td width="37%" colspan="3">{{blanApply.baseInfo.emergency_relation_name}}</td>
                </tr>
              </table>
            </el-tab-pane>
            <el-tab-pane label="申报材料" name="third">
              <td colspan="2"><h2 class="information_tit">上传图片一览</h2></td>
              <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                <tr><td>
                  <div   v-for="(photo,index) in UploadTypeList"  :key="index+'fjfj'">
                    <div v-if="!(blanApply.baseInfo.apply_way =='0' && photo.oneTypeCode=='FJ_1_ATTORNEY')" style="width: 100%">
                    <div style="line-height: 27px;margin-bottom: 5px ;font-size: 14px;padding-left: 5px;    font-weight: 600;
      background-color: #f2f3f5;">» {{photo.oneTypeName}}</div>
                    <div  v-for="(two,indexs) in photo.childData"     :key="indexs+'sdsd'" style="display:flex;align-content: left;margin-top: 10px;margin-bottom: 10px;">
                      <div style="width:150px;padding-left: 20px;">
                        {{two.twoTypeName}}</div>
                      <!--<el-form-item   prop="two.twoAttachIdArr" :rules="[{required: photo.oneTypeCode=='FJ_1_ATTORNEY'?(blanApply.baseInfo.apply_way=='1'?true:false):(photo.oneNotNull=='1'?true:false), message: '请上传'+two.twoTypeName ,tigger:'blur'}]">-->
                      <div style="width:100%;text-align: right;" >
                        <!--<ImgUploaderOneTitle-->
                        <!--:file-type="two.twoTypeCode"-->
                        <!--:canEdit="canEditBoolean"-->
                        <!--:maxCount="1"-->
                        <!--v-model="two.twoAttachIdArr"-->
                        <!--/>-->
                        <img   :src="getImg(two.twoAttachId)" style="width: 180px;height: 150px;" v-if="two.twoAttachId!='' &&two.twoAttachId!='-1'"/>
                        <div style="width: 180px;height: 150px;line-height: 150px;background-color: #e8e8e8;text-align: center;float: right;" v-if="two.twoAttachId=='' ||two.twoAttachId=='-1'">--未上传--</div>
                      </div>
                      </div>
                    </div>
                    <!--</el-form-item>-->
                  </div>
                </td></tr>
                <!--<tr  v-for="(photo,index) in UploadTypeList"  :key="index">-->
                  <!--<td width="20%" align="left" style="padding-left: 1%;">{{photo.name}}：</td>-->
                  <!--<td  style="padding-left: 10px;padding-top: 5px;padding-bottom: 5px;">-->
                    <!--&lt;!&ndash;                    <img src="photo.photos" :file-type="photo.type" :limit="photo.limit" v-model="photo.photos"/>&ndash;&gt;-->
                    <!--<img v-for="pp in photo.photos" :src="getImg(pp)" style="width: 180px;height: 150px;padding-right: 10px;"/>-->
                  <!--</td>-->
                <!--</tr>-->
              </table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-dialog>



    </div>
    </table>
    <el-dialog   :visible.sync="isShowLog" width="900px" >
      <div v-if="cardMarkLogList && cardMarkLogList.length>0">
        <table>
        <tr>
          <td style="padding-bottom: 20px" colspan="5"><h2 class="information_tit">办件记录</h2></td>
        </tr>
        </table>
        <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;margin-bottom: 50px">
          <tr>
            <td width="12%" class="grey">受理编号</td>
            <td width="38%">{{allData.applyNo}}</td>
            <td width="12%" class="grey">姓名</td>
            <td width="38%">{{allData.userName}}</td>
          </tr>
          <tr>
            <td width="12%" class="grey">身份证</td>
            <td width="38%">{{allData.userUid}}</td>
            <td width="12%" class="grey">申请日期</td>
            <td width="38%">{{applyDate}}</td>
          </tr>
          <tr>
            <td width="12%" class="grey">申请业务</td>
            <td width="38%">{{allData.applyType}}</td>
            <td width="12%" class="grey">住址</td>
            <td width="38%">{{allData.userLiving}}</td>
          </tr>
        </table>
        <el-steps  style="padding-bottom: 50px;" direction="vertical" :active="-1" space="60px">
          <el-step  v-for="(logs, indexs) in cardMarkLogList" :key="logs.logId" :title="'【'+logs.optStatusName+'】'+logs.optPartyId">
            <template slot="description">
              <div style="padding-left: 20px;">
                {{logs.optTime}}<br/>
                处理意见：{{logs.optDesc}}
              </div>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div v-else>
       <h3 align="center">您的申请已提交，请耐心等待处理~</h3>
      </div>
    </el-dialog>
    <!--<el-dialog v-else  :visible.sync="isShowLog" width="900px" >
      <tr>
        <td style="padding-bottom: 20px" colspan="5"><h2 class="information_tit">办件记录</h2></td>
      </tr>
    </el-dialog>-->
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  import imgUploader from "../../components/ImgUploader";
  export default {
    name: "CardMaking",
    inject:['reload'],
    components: {
      headers, fixedDiv, footers,personal,imgUploader
    },
    data() {
      return {
        isShowLog:false,
        famlyBirthday:'',
        applyType:'',
        personUid:'',
        enjoyApplyShow:false,
        fmFlag:false,
        fatherShow:false,
        motherShow:false,
        healthInfoShow:false,
        concentratedShow:false,
        pocApplyShow:false,
        tyApplyShow:false,
        birthday:'',
        areaName:'',
        cityName:'',
        provinceName:'',
        clpApplyShow: false,
        activeName3: 'first',
        disabilityList:[],
        disabilityType:[],
        show:false,
        disabilityGrade:[],
        enjoyList:[],
        //儿童
        pocPhotos:[
          {name:'委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
          {name:'户口本主页及本人页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},
          {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
        ],
        //.低保
        blanphotos:[
          {name:'户主委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
          {name:'户口本户主页及家庭成员页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},//
          // {name:'申请人身份证人像面及国徽面',type:'ID_CARD',required:false,photos:[]},//
          {name:'残疾或患病情况等相关证明材料',type:'DISABILITY_OR_ILLNESS',required:false,limit:5,photos:[]},
          {name:'家庭成员收入证明',type:'MEMBER_INCOME',required:false,limit:5,photos:[]},//
          {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
          {name:'收入核对授权书',type:'INCOME_CHECK',required:false,limit:5,photos:[]}//
        ],
        //高龄
        typhotos:[
          {name:'委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
          {name:'户口本主页及本人页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},
          {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
        ],
        //残疾人
        clpPhotos:[
          {name:'委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
          {name:'户口本主页及本人页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},
          // {name:'申请人身份证人像面及国徽面',type:'ID_CARD',required:false,photos:[]},//
          {name:'残疾人证',type:'DISABILITY_CERTIFICATE',required:false,limit:5,photos:[]},
          {name:'城乡居民最低生活保障证',type:'SECURITY_CERTIFICATE',required:false,limit:5,photos:[]},//
          {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
        ],
        photos:[
          {name:'户主委托书',type:'POWER_OF_ATTORNEY',required:false,limit:2,photos:[]},
          {name:'户口本户主页及家庭成员页',type:'PERMANENT_RESIDENCE_BOOKLET',required:false,limit:12,photos:[]},//
          // {name:'申请人身份证人像面及国徽面',type:'ID_CARD',required:false,photos:[]},//
          {name:'残疾或患病情况等相关证明材料',type:'DISABILITY_OR_ILLNESS',required:false,limit:5,photos:[]},
          {name:'家庭成员收入证明',type:'MEMBER_INCOME',required:false,limit:5,photos:[]},//
          {name:'银行卡',type:'BANK_CARD',required:false,limit:5,photos:[]},//
          {name:'收入核对授权书',type:'INCOME_CHECK',required:false,limit:5,photos:[]}//
        ],
        familyUserDialog: false,
        enjoy_treat:'无',
        blanApply:{
          archive_type_code:'',
          nav_name:'',
          canEdit:'true',
          baseInfo:{
            apply_status:0,
            person_name:'',
            person_uid:'',
            apply_way:'',
            idcard_pic_front:'',
            idcard_pic_back:'',
            user_nations_id:'',
            user_nations:'',
            user_idcard_address:'',
            auth_person_uid:'',
            auth_person_name:'',
            to_party_id:'',
            req_reason:'',
            apply_source:'2'
          },
          reqManInfo:{
            bank_relation_id:'',
            bank_type_id:'',
            bank_name:'',
            req_addr:'',
            bank_account_code:'',
            req_man_is:0,
            remark:'',
            serious_ill_id:'',
            dl_id:'',
            health_id:'',
            dt_id:'',
            org_nature_id:'',
            org_name:'',
            work_capacity_id:'',
            city_is:'',
            culture:'',
            relation_id:'',
            relation_name:'',
            person_sex:1,
            person_birthday:'',
            person_age:'',
            person_uid:'',
            person_name:'',
            nations_type_id:'',
            nations_type_name:'',
            regi_address:'',
            living_address:'',
            // 政治面貌：
            politics:'1001',
            politics_name:'群众',
            soical_ins_number:'',
            idcard_pic_front:'',
            idcard_pic_back:'',
            bank_account_name:'',
            bank_person_uid:'',
            income_wages:0,
            income_total:'',
            income_pension:0,
            income_odd_job:0,
            income_unemployment_insurance:0,
            income_living_expenses:0,
            income_rent:0,
            income_operating:0,
            income_alimony:0,
            income_raise:0,
            income_other:0,
            gsc_is:'0',
            marriage:'23001',
            marriage_name:'未婚',
          },
          familyInfo:{
            family_uid:'',
            family_name:'',
            party_id:'',
            family_person_count:1,
            family_ensure_count:1,
            proverty_causes:[],
            help_type:[],
            housing_info:'',
            housing_area:'',
            housing_rent:'0',
            no_cut_family_income:'',
            deposit:'',
            property_frig:0,
            property_air_conditioning:0,
            property_washing_machine:0,
            property_phone:0,
            property_computer:0,
            property_television:0,
            property_other:'',

          },
          members:[],
          currMember:{},
          photos:[],
          typhotos:[],
          blanphotos: [],
        },//包含baseeInfo(申报基本信息）
        idcard_pic_front:'',
        idcard_pic_front_img:'',
        idcard_pic_back:'',
        idcard_pic_back_img:'',
        isShow:true,
        apply_way:0,
        loginPerson:{
          person_name:'',
          person_uid:'',
          person_tel:'',
          isCertification:'',
          idcardPicFront:'',
          idcardPicBack:'',
          userIdcardAddress:'',
          userNationsId:'',
          userNations:'',
        },
        frontFileList:[],
        backFileList:[],
        fmfrontFileList:[],
        fmbackFileList:[],
        city_is:[
          {name:'城市户口',id:'1'},
          {name:'农村户口',id:'0'}
        ],
        housing_type:[],
        house_type:[],
        proverty_causes:[],
        help_type:[],
        bank_type:[],
        nations_type:[],relation:[],marital_status:[],political_status:[],regi_kind:[],
        education_levels:[],work_capacity:[],party_nature_type:[],health:[],serious_name:[],
        person_type:[],dis_type:[],dis_level:[],
        archive_type_code:'',
        qxAlertFlag:false,
        alertMsg:'',
        alertType:'',
        activeName: 'second',
        card_making_list: [],
        activeName1:'',
        loginShow:false,
        gotoIndex:false,
        dataEvaluationObj:{},
        dataEvaluationList:[],
        dialogVisible:false,
        dialogVisiblePj:false,
        buttonShow:false,
        message:'',
        applyId:'',
        blanApplyShow: false,
        help_str:'',
        proverty_str:'',
        famlyPeopleOne:[],
        disabilityList2:[],
        cardMarkLogList:[],
        UploadTypeList:[],
        dataTypeList:[],
        typePhotos:[],
        upId:'',
        allData:'',
        applyDate:'',
      };
    },

    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      var upId = this.$route.query.upId;
      if (!upId==""){
        this.upId=upId;
      }
      this.getListData();
    },

    methods: {

      handleClick(tab, event){

      },
      toDelete(applyId,service_code,nav_name_apply,canEdit){
        this.$confirm('此操作将永久删除该申请, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.gotoDelete(applyId,service_code)
        }).catch(() => {

        });
      },
      gotoDelete(applyId,service_code){
        //删除保存得业务
        var tt=this;
        this.$https.post('api/ywt/apply/deleteBizApply.do', {apply_id:applyId,archive_type_code:service_code},(response)=>{
          if (response.status === 200 && response.data.code===200 ) {
            tt.$message.success('删除成功!');
            tt.reload();
          } else {
            tt.$message.error('删除失败，请稍后再试!');
          }
      });
      },
      initEvaluation(applyId){
        this.activeName1=applyId;
        this.applyId='';
        this.dataEvaluationObj={};
        this.message='';
        var tt=this;
        this.$https.post("api/apply/getApplyEvaluationIndex.do",{id:applyId},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data!=null) {
            tt.dataEvaluationObj=response.data.data;
            tt.applyId=applyId;
            tt.dialogVisible=true;
          } else {
            tt.$message.error('网络异常，请刷新页面重试!');
          }
        })
      },
      getDisability(){

      },
      getFamilyDictData(){
        let data={
          types:['proverty_causes','help_type']
        };
        var tt=this;
        this.$https.post('api/ywt/base/getDictData.do',data,response=>{
          if (response.data.code===200){
            tt.help_str='';
            tt.proverty_str='';
            // this.$util.readData(response.data.data,this)
            tt.help_type=response.data.data.help_type;
            tt.proverty_causes=response.data.data.proverty_causes;
            if (tt.proverty_causes && tt.proverty_causes.length>0&&tt.blanApply.familyInfo.proverty_causes&&tt.blanApply.familyInfo.proverty_causes.length>0){
              for (let i = 0; i <tt.blanApply.familyInfo.proverty_causes.length ; i++) {
                for (let j = 0; j < tt.proverty_causes.length; j++) {
                  if (tt.proverty_causes[j].id==tt.blanApply.familyInfo.proverty_causes[i]){
                    if (tt.proverty_str==''){
                      tt.proverty_str=tt.proverty_causes[j].name;
                      break;
                    }else {
                      tt.proverty_str=tt.proverty_str+","+tt.proverty_causes[j].name;
                      break;
                    }
                  }
                }
              }

            }
            if(tt.help_type && tt.help_type.length>0 && tt.blanApply.familyInfo.help_type && tt.blanApply.familyInfo.help_type.length>0){
              for(var i=0;i<tt.blanApply.familyInfo.help_type.length;i++){
                for(var j=0;j< tt.help_type.length;j++){
                  if(tt.help_type[j].id==tt.blanApply.familyInfo.help_type[i]){
                    if(tt.help_str==''){
                      tt.help_str=tt.help_type[j].name;
                      break;
                    }else{
                      tt.help_str=tt.help_str+","+tt.help_type[j].name;

                      break;
                    }
                  }
                }
              }
            }
          }
        })
      },
      showLog(applyId,logData){
        this.activeName1=applyId;
        this.cardMarkLogList=logData;
        this.isShowLog=true;
        this.getApplyLog(applyId);
      },
      getApplyLog(applyId){
        var tt=this;
        this.$https.post("api/apply/getApplyLog.do",{applyId:applyId},response=>{
          if (response.status === 200 && response.data.code===200) {
            tt.allData = response.data.data;
            var s = tt.allData.applyDate.substring(0,4);
            var s2 = tt.allData.applyDate.substring(4,6);
            var s3 = tt.allData.applyDate.substring(6,8);
            this.applyDate=s+"-"+s2+"-"+s3;
          }
        });
      },
      showMember(member,index){
        var tttt=this;
        member.__index=index;
        this.blanApply.currMember=member;
        var idcard_pic_front=this.blanApply.currMember.idcard_pic_front;
        var idcard_pic_back=this.blanApply.currMember.idcard_pic_back;
        if(idcard_pic_front && idcard_pic_front!=''){
          var imgUrl=this.getImg(idcard_pic_front);
          this.blanApply.currMember.idcard_pic_front_img=imgUrl;
          // console.log(this.user_idcard_one_file)
        }
        if(idcard_pic_back && idcard_pic_back!=''){
          var imgUrl=this.getImg(idcard_pic_back);
          this.blanApply.currMember.idcard_pic_back_img=imgUrl;
        }

        if (this.blanApply.members[index].dis_info.length>0){
          tttt.disabilityList2=[];
          tttt.disabilityType2=[];
          tttt.disabilityGrade2=[];
          /*var disabilityType = tttt.blanApply.reqManInfo.dt_info.split(",");*/
          for (let i = 0; i <tttt.blanApply.members[index].dis_info.length; i++) {
            tttt.disabilityType2+=tttt.blanApply.members[index].dis_info[i].dt_name;
            tttt.disabilityGrade2+=tttt.blanApply.members[index].dis_info[i].dl_name;
          }
          /* var disabilityGrade = tttt.blanApply.reqManInfo.dl_info.split(",");*/
          if (tttt.disabilityType2.length==0){
            tttt.disabilityList2=[];
          }else {
            for (let i = 0; i < tttt.disabilityType2.length; i++) {
              if (tttt.disabilityList2.length==0){
                tttt.disabilityList2=tttt.disabilityType2[i]+'('+tttt.disabilityGrade2[i]+')';
              }else {
                tttt.disabilityList2+=','+tttt.disabilityType2[i]+'('+tttt.disabilityGrade2[i]+')';
              }
            }
          }
        }
        this.famlyPeopleOne=this.blanApply.members[index];
        var s = this.famlyPeopleOne.person_birthday.substr(0,4);
        var s1 = this.famlyPeopleOne.person_birthday.substr(4,2);
        var s2 = this.famlyPeopleOne.person_birthday.substr(6,2);
        this.famlyBirthday=s+'-'+s1+'-'+s2;
        this.familyUserDialog=true;
      },
      showOldEvaluation(applyId){
        this.activeName1=applyId;
        this.$https.post("api/apply/getApplyEvaluationScoreList.do",{applyId:applyId},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data!=null) {
            this.dataEvaluationList=response.data.data;
            this.dialogVisiblePj=true;
          } else {
            // this.$router.push({path:'/peopleLogin'});
          }
        })
      },
      getImg(imgId){
        var dd=this.$util.req.getshowImg(imgId);
        return dd;
      },

      getListData() {
        this.$https.post("/api/apply/getApplyList.do", {}, response => {
          var tt=this;
          if (response.status === 200 && response.data.code === 200) {
            if (!tt.$util.isEmpty(response.data.data)) {/*showLog(item.applyId,item.logData*/
              tt.card_making_list = response.data.data;
              for (let i = 0; i < tt.card_making_list.length; i++) {
                if (tt.upId==tt.card_making_list[i].applyId){
                  tt.showLog(tt.upId,tt.card_making_list[i].logData)
                }
              }
            }
          }

        });
      },
      //获取最后一个步骤的名称
      getFinalStep(item) {
        if (item.flowStatus === "3") {
          return item.applyStatusName
        } else {
          return '审批结束'
        }
      },
      //判断当前处于第几个步骤
      getCurrentStep(item) {
        return parseInt(item.flowStatus) + 1
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      }
      ,
      gotoEdit(applyId,service_code,nav_name_apply,canEdit){
        let options={
          apply_id: applyId,
          archive_type_code: service_code,
        }
        if('BLAN'==service_code || 'NTF'==service_code){
          this.urlTo('blanApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})
        } /*else if('CLP_LIV'==service_code || 'CLP_HLF'==service_code){
          this.urlTo('clpApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})
        }else if('ORP'==service_code ||  'POC'==service_code || 'SPEC_ORP'==service_code || 'BLAN_ORP'==service_code) {
          this.urlTo('pocApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})
        }*/
        else if('JDST'==service_code){
          this.urlTo('jdApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})
        }else {
          this.urlTo('tyApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})
        }

      },
      //待遇享受
      gotoLookEnjoy(applyId,personUid){
        var t=this;
        this.activeName1=applyId;
        //
        // this.$https.post("api/pu/peopleUserByOne.do",{personUid:personUid},response=>{
        //   if (response.status === 200 && response.data.code===200) {
        //     t.enjoyApplyShow=true;
        //       t.enjoyList=response.data.data;
        //   }
        // })

        this.$https.post("/api/zj/getAllEnjoyTreat.do", {person_uid: personUid}, response => {
          if (response.status === 200 && response.data.code === 200) {
            t.enjoyApplyShow=true;
            if (!this.$util.isEmpty(response.data.data)) {
              t.enjoyList = response.data.data;
            }
          }
        });
      },
      //申报详情
      gotoBl(applyId,service_code,nav_name_apply,canEdit){
        this.activeName1=applyId;
        this.applyType=nav_name_apply;
        this.archive_type_code=service_code
        let options={
          apply_id: applyId,
          archive_type_code: service_code,
        }
        if('BLAN'==service_code || 'NTF'==service_code){
          this.activeName3="first";
          var tttt=this;
          this.$https.post("api/ywt/apply/getApplyBlan.do",options,response=>{
            if (response.status === 200 && response.data.code===200) {
              let rtData=response.data.data.applyContent;
              tttt.blanApply.baseInfo=rtData.baseInfo;
              tttt.blanApply.familyInfo=rtData.familyInfo;
              tttt.blanApply.reqManInfo=rtData.reqManInfo;
              tttt.blanApply.members=rtData.members;
              if(rtData.baseInfo && rtData.baseInfo.to_party_id){
                //异步获取区划信息
                tttt.party_id=rtData.baseInfo.to_party_id;
                tttt.party_ids(rtData.baseInfo.to_party_id);
              }else{
                tttt.initDepart();
              }

              tttt.getFamilyDictData();
              // for (let i = 0; i < tttt.; i++) {
              //
              // }
              tttt.blanApplyShow=true;
              let localPhotos=rtData.photos;
              let photoTypes = this.blanphotos;//tttt.blanApply.photos;
              let typeLength = photoTypes.length;
              tttt.getUploadTypeList(service_code,localPhotos);
              /*切割日期得到生日*/
              var s = tttt.blanApply.reqManInfo.person_birthday.substr(0,4);
              var s1 = tttt.blanApply.reqManInfo.person_birthday.substr(4,2);
              var s2 = tttt.blanApply.reqManInfo.person_birthday.substr(6,2);

              this.birthday=s+'-'+s1+'-'+s2;
              // for (let i=0;i<typeLength;i++){
              //   photoTypes[i].photos=[];
              //   let typeName = photoTypes[i].type;
              //   if (localPhotos[typeName]&&localPhotos[typeName].length>0){
              //     photoTypes[i].checked=true;
              //     for (let j=0;j<localPhotos[typeName].length;j++){
              //       photoTypes[i].photos.push(localPhotos[typeName][j])
              //     }
              //   }
              // }
              tttt.disabilityList=[];
              tttt.disabilityType=[];
              tttt.disabilityGrade=[];
              /*var disabilityType = tttt.blanApply.reqManInfo.dt_info.split(",");*/
              for (let i = 0; i <tttt.blanApply.reqManInfo.dis_info.length; i++) {
                  tttt.disabilityType+=tttt.blanApply.reqManInfo.dis_info[i].dt_name;
                  tttt.disabilityGrade+=tttt.blanApply.reqManInfo.dis_info[i].dl_name;
              }
             /* var disabilityGrade = tttt.blanApply.reqManInfo.dl_info.split(",");*/
              if (tttt.disabilityType.length==0){
                tttt.disabilityList=[];
              }else {
                for (let i = 0; i < tttt.disabilityType.length; i++) {
                  if (tttt.disabilityList.length==0){
                    tttt.disabilityList=tttt.disabilityType[i]+'('+tttt.disabilityGrade[i]+')';
                  }else {
                    tttt.disabilityList+=','+tttt.disabilityType[i]+'('+tttt.disabilityGrade[i]+')';
                  }
                }
              }
            } else {
              // this.$router.push({path:'/peopleLogin'});
              tttt.$message.error('网络异常，请刷新页面重试!');
              return false;
            }
          })
          /*this.urlTo('blanApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})*/
        }
        else if('CLP_LIV'==service_code || 'CLP_HLF'==service_code ||'ORP'==service_code ||  'POC'==service_code || 'SPEC_ORP'==service_code || 'BLAN_ORP'==service_code  || 'OLD'==service_code){
          if ('POC'==service_code || 'SPEC_ORP'==service_code || 'BLAN_ORP'==service_code ){
            //如果是儿童，就显示父母信息，孤儿除外
            this.fmFlag=true
          }else {
            this.fmFlag=false
          }
          /*高龄儿童残疾人*/
          this.activeName3="first";
          this.clpApplyShow=true;
          let tttt=this;
          this.$https.post("api/ywt/apply/getApplyClp.do",options,response=>{
            if (response.status === 200 && response.data.code===200) {

              let rtData=response.data.data.applyContent;
              tttt.blanApply.baseInfo=rtData.baseInfo;
              if(rtData.clpInfo){
                var disability_number=rtData.clpInfo.disability_number;
                if(disability_number){
                  var type=disability_number.substring(18,19);
                  if(type==7){
                    tttt.disCan=false;
                  }
                }
                if(rtData.is_blan=='0'){
                  this.blan_type=[  {name:'无',id:'0'}];
                }else{
                  this.blan_type=[
                    {name:'城市低保',id:'blan_city'},
                    {name:'农村低保',id:'blan_side'}];
                }
                tttt.blanApply.reqManInfo=rtData.clpInfo;
              }
              if(rtData.baseInfo && rtData.baseInfo.to_party_id){
                //异步获取区划信息
                tttt.party_id=rtData.baseInfo.to_party_id;
                tttt.party_ids(rtData.baseInfo.to_party_id);
              }else{
                tttt.initDepart();
              }
              if (tttt.blanApply.reqManInfo.centralized_time.length>7){
                //切割入住日期
                var s1 = this.blanApply.reqManInfo.centralized_time.substring(0,4);
                var s2 = this.blanApply.reqManInfo.centralized_time.substring(4,6);
                var s3 = this.blanApply.reqManInfo.centralized_time.substring(6,8);
                this.blanApply.reqManInfo.centralized_time=s1+"-"+s2+"-"+s3;
              }
             /* 残疾类型切割拼接*/
              tttt.disabilityList=[];
              var disabilityType = tttt.blanApply.reqManInfo.dt_info.split(",");
              var disabilityGrade = tttt.blanApply.reqManInfo.dl_info.split(",");
              if (disabilityType.length==0){
                tttt.disabilityList=[];
              }else {
                for (let i = 0; i < disabilityType.length; i++) {
                  if (tttt.disabilityList.length==0){
                    tttt.disabilityList=disabilityType[i]+'('+disabilityGrade[i]+')';
                  }else {
                    tttt.disabilityList+=','+disabilityType[i]+'('+disabilityGrade[i]+')';
                  }
                }
              }
              if (this.blanApply.reqManInfo.dis_apply_time.length==8){
                var startDate1 = this.blanApply.reqManInfo.dis_apply_time.substring(0,4);
                var startDate2 = this.blanApply.reqManInfo.dis_apply_time.substring(4,6);
                var startDate3 = this.blanApply.reqManInfo.dis_apply_time.substring(6,8);
                this.blanApply.reqManInfo.dis_apply_time=startDate1+'-'+startDate2+'-'+startDate3
              }
              if (this.blanApply.reqManInfo.dis_invalid_time.length==8){
                var endDate1 = this.blanApply.reqManInfo.dis_invalid_time.substring(0,4);
                var endDate2 = this.blanApply.reqManInfo.dis_invalid_time.substring(4,6);
                var endDate3 = this.blanApply.reqManInfo.dis_invalid_time.substring(6,8);
                this.blanApply.reqManInfo.dis_invalid_time=endDate1+'-'+endDate2+'-'+endDate3
              }
              let localPhotos=rtData.photos;
              tttt.getUploadTypeList(service_code,localPhotos);
              let photoTypes = tttt.clpPhotos;//tttt.blanApply.photos;
              let typeLength = photoTypes.length;
              // for (let i=0;i<typeLength;i++){
              //   photoTypes[i].photos=[];
              //   let typeName = photoTypes[i].type;
              //   if (localPhotos[typeName]&&localPhotos[typeName].length>0){
              //     photoTypes[i].checked=true;
              //     for (let j=0;j<localPhotos[typeName].length;j++){
              //       photoTypes[i].photos.push(localPhotos[typeName][j])
              //     }
              //   }
              // }
              var s = tttt.blanApply.reqManInfo.person_birthday.substr(0,4);
              var s1 = tttt.blanApply.reqManInfo.person_birthday.substr(4,2);
              var s2 = tttt.blanApply.reqManInfo.person_birthday.substr(6,2);
              this.birthday=s+'-'+s1+'-'+s2;
              // tttt.photos=tttt.blanApply.photos;
              tttt.idcard_pic_front=tttt.blanApply.baseInfo.idcard_pic_front;
              tttt.idcard_pic_back=tttt.blanApply.baseInfo.idcard_pic_back;

              if(tttt.idcard_pic_front && tttt.idcard_pic_front!=''){
                var imgUrl=tttt.getImg(tttt.idcard_pic_front);
                tttt.idcard_pic_front_img=imgUrl;
              }
              if(tttt.idcard_pic_back && tttt.idcard_pic_back!=''){
                var imgUrl=tttt.getImg(tttt.idcard_pic_back);
                tttt.idcard_pic_back_img=imgUrl;
              }
              tttt.idcard_pic_front_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_front;
              tttt.idcard_pic_back_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_back;

              if(tttt.idcard_pic_front_jf && tttt.idcard_pic_front_jf!=''){
                tttt.idcard_pic_front_img_jf=tttt.getImg(tttt.idcard_pic_front_jf);
              }
              if(tttt.idcard_pic_back_jf && tttt.idcard_pic_back_jf!=''){
                tttt.idcard_pic_back_img_jf=tttt.getImg(tttt.idcard_pic_back_jf);
              }
            } else {
              // this.$router.push({path:'/peopleLogin'});
              tt.$message.error('网络异常，请刷新页面重试!');
              return false;
            }
          })
          /*this.urlTo('clpApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})*/
        }else{
          this.tyApplyShow=true;
          this.activeName3="first";
          var tttt=this;
          this.$https.post("api/ywt/apply/getApplyClp.do",options,(response)=>{
            console.log(response)
            if (response.data.code!==200){
              // tttt.$toast.fail(response.data.msg)
            }else {
              let rtData=response.data.data.applyContent;
              tttt.blanApply.baseInfo=rtData.baseInfo;
              if(rtData.clpInfo){
                tttt.blanApply.reqManInfo=rtData.clpInfo;
              }

              if(rtData.baseInfo && rtData.baseInfo.to_party_id){
                //异步获取区划信息
                tttt.party_id=rtData.baseInfo.to_party_id;
                tttt.party_ids(rtData.baseInfo.to_party_id);
              }else{
                tttt.initDepart();
              }
              var s = tttt.blanApply.reqManInfo.person_birthday.substr(0,4);
              var s1 = tttt.blanApply.reqManInfo.person_birthday.substr(4,2);
              var s2 = tttt.blanApply.reqManInfo.person_birthday.substr(6,2);
              this.birthday=s+'-'+s1+'-'+s2;
              let localPhotos=rtData.photos;
              let photoTypes = tttt.typhotos;//tttt.blanApply.photos;
              let typeLength = photoTypes.length;
              tttt.getUploadTypeList(service_code,localPhotos);
              // for (let i=0;i<typeLength;i++){
              //   photoTypes[i].photos=[];
              //   let typeName = photoTypes[i].type;
              //   if (localPhotos[typeName]&&localPhotos[typeName].length>0){
              //     photoTypes[i].checked=true;
              //     for (let j=0;j<localPhotos[typeName].length;j++){
              //       photoTypes[i].photos.push(localPhotos[typeName][j])
              //     }
              //   }
              // }
              // tttt.photos=tttt.blanApply.photos;
              tttt.idcard_pic_front=tttt.blanApply.baseInfo.idcard_pic_front;
              tttt.idcard_pic_back=tttt.blanApply.baseInfo.idcard_pic_back;

              if(tttt.idcard_pic_front && tttt.idcard_pic_front!=''){
                var imgUrl=tttt.getImg(tttt.idcard_pic_front);
                tttt.idcard_pic_front_img=imgUrl;
              }
              if(tttt.idcard_pic_back && tttt.idcard_pic_back!=''){
                var imgUrl=tttt.getImg(tttt.idcard_pic_back);
                tttt.idcard_pic_back_img=imgUrl;
              }
              tttt.idcard_pic_front_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_front;
              tttt.idcard_pic_back_jf=tttt.blanApply.reqManInfo.guardian_idcard_pic_back;

              if(tttt.idcard_pic_front_jf && tttt.idcard_pic_front_jf!=''){
                tttt.idcard_pic_front_img_jf=tttt.getImg(tttt.idcard_pic_front_jf);
              }
              if(tttt.idcard_pic_back_jf && tttt.idcard_pic_back_jf!=''){
                tttt.idcard_pic_back_img_jf=tttt.getImg(tttt.idcard_pic_back_jf);
              }
            }
          });
          /*this.urlTo('tyApply',{apply_id:applyId,archive_type_code:service_code,nav_name:nav_name_apply,canEdit:canEdit})*/
        }
      },
      getUploadTypeList(service_code,localPhotos){
        this.UploadTypeList=localPhotos
        // var tt=this;
        // tt.UploadTypeList=[];
        // tt.dataTypeList=[];
        // this.$https.post("/api/ywt/base/getUploadTypeList.do",{archive_type:service_code},(response)=>{
        //   if (response.status === 200){
        //     this.dataTypeList=response.data.data.typeList;
        //     for (let i = 0; i < tt.dataTypeList.length; i++) {
        //       tt.typePhotos=[];
        //       //为身份证就单独封装
        //       /*if (tt.dataTypeList[i].type=="ID_CARD"){
        //         tt.typePhotos.push(tt.blanApply.baseInfo.idcard_pic_front);
        //         tt.typePhotos.push(tt.blanApply.baseInfo.idcard_pic_back);
        //       }*/
        //       if (localPhotos[tt.dataTypeList[i].type] && localPhotos[tt.dataTypeList[i].type].length>0){
        //         for (let j = 0; j < localPhotos[tt.dataTypeList[i].type].length; j++) {
        //           tt.typePhotos.push(localPhotos[tt.dataTypeList[i].type][j]);
        //         }
        //       }
        //       tt.UploadTypeList.push({name:tt.dataTypeList[i].title,type:tt.dataTypeList[i].type,required:tt.dataTypeList[i].require,limit:tt.dataTypeList[i].limit,photos:tt.typePhotos})
        //     }
        //   }
        // });
      },
      party_ids(nv){
        var tt=this;
        this.$https.post("api/pu/getPuUserAreaByPartyId.do",{partyId:nv},(response)=>{
          if (response.status === 200 && response.data.code==200 && response.data.data){
            var csData=[];
            if(response.data.data.provinceId){
              csData[0]=response.data.data.provinceId;
              this.provinceName=response.data.data.provinceName;
            }
            if(response.data.data.cityId){
              csData[1]=response.data.data.cityId;
              this.cityName=response.data.data.cityName;
            }
            if(response.data.data.areaId){
              csData[2]=response.data.data.areaId;
              this.areaName=response.data.data.areaName;
            }
            // tt.selectedRegion=csData;
            // let cs=tt.$refs['cs'];
            // cs.panel.activePath=[];
            // cs.panel.loadCount=0;
            // cs.panel.lazyLoad();
            // if(tt.selectedRegion.length>0){
            //   tt.getDepartAreas(tt.selectedRegion[tt.selectedRegion.length-1],0);
            // }
            if(response.data.data.departyId){
              tt.selecteddepartOption[0]=response.data.data.departyId
              tt.blanApply.baseInfo.to_party_id=response.data.data.departyId;
              tt.blanApply.reqManInfo.party_id=response.data.data.departyId;
              tt.blanApply.familyInfo.party_id=response.data.data.departyId;
              // if(this.getPartyId){
              //   this.getPartyId(areaInfo.departyId);
              // }
            }
          }
        });
      },

      submitData(){
        if(this.message==''){
            this.qxAlertFlag=true;
            this.alertMsg='请填写评价描述';
            this.alertType="error";
            return false;
        }
        this.buttonShow=true;
        this.qxAlertFlag=false;
        var index_score="";
        if(this.dataEvaluationObj.indexData && this.dataEvaluationObj.indexData.length>0){
          for(var num = 0;num<this.dataEvaluationObj.indexData.length;num++){
            console.log(this.dataEvaluationObj.indexData[num].scores);//1,2,3,4,5,6,7,8,9
            if(num==0){
              index_score=this.dataEvaluationObj.indexData[num].eiId+":"+this.dataEvaluationObj.indexData[num].webScores+":"+this.dataEvaluationObj.indexData[num].eiTotalScore
            }else{
              index_score=index_score+";"+this.dataEvaluationObj.indexData[num].eiId+":"+this.dataEvaluationObj.indexData[num].webScores+":"+this.dataEvaluationObj.indexData[num].eiTotalScore
            }
          }
        }
        const options={
          serviceCode:this.dataEvaluationObj.serviceCode,
          fromPartyId:this.dataEvaluationObj.fromPartyId,
          sumScore:this.dataEvaluationObj.sumScore,
          message:this.message,
          applyId:this.applyId,
          index_score:index_score,
          esSource:"3"
        }
        var tt=this;
        this.$https.post("api/apply/saveApplyEvaluationIndex.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
              tt.$alert('感谢您的评价，您可以通过:<br />【个人中心->我的评价】查看评价记录',"提交成功", {
                confirmButtonText: '确定',
                dangerouslyUseHTMLString:true,
                callback: action => {
                  tt.buttonShow=false;
                  tt.dialogVisible=false;
                  tt.reload();
                }
            });
          } else {
            // this.$router.push({path:'/peopleLogin'});
            tt.$message.error('网络异常，请刷新页面重试!');
            return false;
          }
        })
      }
    }
  }
</script>

<style>
  .tccss .el-dialog__headerbtn {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 0;
    background: 0 0;
    border: none;
    outline: 0;
    cursor: pointer;
    font-size: 24px;
  }
  .advice_tab_new td {
    padding-bottom: 0px;
  }
  .advice_tab_new .el-select{
    margin-left: 0px;
  }
  .advice_tab_new{margin:0px auto; font-size:14px;}
  .advice_tab_new td span{padding-right:2px;}
  .advice_tab_new td span img{position:relative; top:2px; margin-right:1px;}
  .advice_tab_new textarea{height:50px;width:97%; padding:0px 1.5%;border:1px solid #dbdbdb; padding-top:10px; line-height:26px; font-family:"微软雅黑";}
  .advice_tab_new td.enclosuer{}
  .advice_tab_new td.enclosuer a{margin-right:20px;}
  .stepDivCss .el-step__description {
    padding-right: 10%;
    margin-top: -5px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 20px;
    color:#85888e;
  }
  .stepDivCss .el-step__title {
    font-size: 14px;
    line-height: 38px;
    font-weight: 600;
    color: #303133;
  }
  .personal_right .el-card__header {
    padding: 9px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }


  .dialog_css12 .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .dialog_css12 .el-dialog__header {
    padding: 0px;
  }
  .dialog_css12 .el-dialog__headerbtn .el-dialog__close {
    color: #000000;
    font-size: 20px;
    font-weight: 900;
  }

  .div-first-label{
    -webkit-box-flex: 0;
    -webkit-flex: none;
    flex: none;
    box-sizing: border-box;
    width: 6.2em;
    margin-right: 12px;
    color: #646566;
    text-align: left;
    word-wrap: break-word;
  }
  .div-first {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    padding: 0px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    /*line-height: 24px;*/
    background-color: #fff;
    /*padding-top: 5px;*/
    /*padding-bottom: 5px;*/
  }
  .div-first::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    bottom: 0;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
  }
  .el-step.is-vertical .el-step__title{
    color: black;
  }
</style>




// WEBPACK FOOTER //
// src/pages/personal/CardMaking.vue